var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileColoredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 118,
    viewBox: "0 0 99 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4384 22.1249C71.4384 34.3442 61.457 44.2499 49.1443 44.2499C36.8317 44.2499 26.8503 34.3442 26.8503 22.1249C26.8503 9.90567 36.8317 0 49.1443 0C61.457 0 71.4384 9.90567 71.4384 22.1249ZM3.62707 102.549C0.402623 100.129 -0.836525 95.8936 0.580217 92.1358C8.29547 72.1739 27.608 58.9946 49.1513 58.9897C70.6945 58.9848 90.0131 72.1553 97.7376 92.1136C99.1942 95.8528 97.9011 100.056 94.7056 102.512C82.1244 112.218 66.3105 118 49.1441 118C32.6612 118.025 16.6419 112.587 3.62707 102.549Z",
    fill: "url(#paint0_linear_341_2364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_2364",
    x1: -1.65614,
    y1: 122.092,
    x2: 120.861,
    y2: 90.2954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileColoredIcon);
export default __webpack_public_path__ + "static/media/profile-colored-icon.0f974bed3c86c39b7f943c3205a98745.svg";
export { ForwardRef as ReactComponent };